import i18n from '@shared/config/i18n';
import {
  ChildBase,
  deleteInvocesToken,
  domenUploadFile,
  invocesToken,
  newInvocesToken,
  rootToken,
  maxInvocePrice,
  minInvocePrice,
} from '../defaults';

const { t } = i18n;

export type Token = 'add-link' | 'add-file';

/* eslint-disable */
export const addButton = (token: Token): ChildBase => ({
  spec: 'button-text',
  token,
  data: {
    label: token === 'add-link' ? t('AddLink')! : t('AddFile')!,
    visible: true,
  },
  styles: { paddingTop: '8px' },
  meta: {
    triggers: [
      {
        events: ['on-click'],
        targets: [token],
        handlers: [`add-new-link-item-${token}`],
      },
    ],
    actions: [
      {
        kind: 'func',
        token: `add-new-link-item-${token}`,
        spec: {
          func: `({hashMap, source, setSduiSource}) => {
  const newInvoces = source.child.find(({token}) => token === '${rootToken}').child.find(({token}) => token === '${invocesToken}').child.find(({token}) => token === '${newInvocesToken}').child
  const addlinkItemString = hashMap['${invocesToken}'].data.customData.addItemFunc
  const addlinkItemFunc = new Function('return '+addlinkItemString)();
  const paymentTypesList = hashMap['${invocesToken}'].data.customData.paymentTypesList
 
  const newInvoce = addlinkItemFunc.call(null, {
    id: 'new-'+newInvoces.length,
    minInvocePrice: ${minInvocePrice},
    maxInvocePrice: ${maxInvocePrice},
    invocesToken: '${invocesToken}',
    horisontalInvocesToken: '${newInvocesToken}',
    domenUploadFile: '${domenUploadFile}',
    paymentTypesList,
    token: '${token}',
    readOnly: hashMap['${invocesToken}'].data.readOnly,
    rootToken: '${rootToken}',
    deleteButtonIcon: true,
    isStatusesSelect: false,
    valid: false,
    canChangeReadonly: true,
    deleteInvocesToken: '${deleteInvocesToken}'
  })
  newInvoces.push(newInvoce)
  setSduiSource({source, add: true})
}`,
        },
      },
    ],
  },
});
/* eslint-enable */
